import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo_home.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "banda upper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "logoHome mb-3" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = { class: "languageSelector mb-2" }
const _hoisted_5 = { class: "banda center" }
const _hoisted_6 = { class: "banda lower" }
const _hoisted_7 = { class: "w-500 text-center" }
const _hoisted_8 = { class: "mt-4 buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-link", { active: _ctx.$store.state.selectedLanguage == 'it-IT' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.state.setLanguage('it-IT')))
          }, "ITA", 2)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-link", { active: _ctx.$store.state.selectedLanguage == 'en-US' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.state.setLanguage('en-US')))
          }, "ENG", 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _createVNode(_component_localized_text, {
          class: "title-1 text-uppercase",
          localizedKey: "Crea la tua tavola",
          text: "Crea la tua tavola"
        }),
        _createVNode(_component_localized_text, {
          class: "title-3 mt-4",
          localizedKey: "TAITÙ By You",
          text: "TAITÙ By You"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_localized_text, {
          localizedKey: "Divertiti con il configuratore TAITÙ",
          text: "Divertiti con il configuratore TAITÙ! Mixa tra loro le Collezioni che preferisci per creare la Tavola dei tuoi sogni."
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-hollow",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/presets/')))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Parti da una tavola suggerita",
            text: "Parti da una tavola suggerita"
          })
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-hollow ms-3",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.newTavola && _ctx.newTavola(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Inizia da zero",
            text: "Inizia da zero"
          })
        ])
      ])
    ])
  ]))
}